import { useTranslation } from 'react-i18next'
import type { HistoryEntry } from './types'
import { useStaffLookup } from './ui'

/** Geçmiş satırının metni: kişi içeren olaylarda kişinin adı, durum/öncelikte çevrilmiş değer, gerekçe/madde adı. */
export function useHistoryText() {
  const { t } = useTranslation()
  const { nameOf } = useStaffLookup()
  return (h: HistoryEntry) => {
    let detail = h.detail ?? ''
    if (h.userId !== undefined) detail = h.userId ? nameOf(h.userId) : '—'
    else if (h.kind === 'priority') detail = t(`projects.priority.${detail}`)
    return t(`projects.history.${h.kind}`, {
      defaultValue: t('projects.history.updated'),
      status: h.status ? t(`projects.taskStatus.${h.status}`) : '',
      detail,
      note: h.note ?? '',
    })
  }
}
